import React, { lazy } from 'react';
import Loadable from 'ui-component/Loadable';

// project imports
import MainLayout from 'layout/MainLayout';

// login option 3 routing
const Typing = Loadable(lazy(() => import('views/typing')));

// ===========================|| AUTHENTICATION ROUTING ||=========================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/typing',
      element: <Typing />
    }
  ]
};

export default AuthenticationRoutes;
